var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M19.875 18.749a1.124 1.124 0 1 1 0 2.25H4.125a1.124 1.124 0 1 1 0-2.25Zm-8.333-15.66a1.22 1.22 0 0 1 1.308.257l4.798 4.727c.47.462.47 1.209 0 1.67-.234.231-.541.347-.848.347s-.615-.116-.849-.346L13.2 7.034V16a1.19 1.19 0 0 1-1.2 1.182A1.19 1.19 0 0 1 10.8 16V7.034L8.05 9.744a1.21 1.21 0 0 1-1.697 0 1.17 1.17 0 0 1 0-1.671l4.798-4.727c.11-.11.244-.196.392-.256"
})));
export default SvgGemUpload;